module.exports = __webpack_public_path__ + "img/unabled.d8350fcc.svg";